import React from 'react';
import env from 'env';
//import { Table } from 'shared/table/table';
//import utils from 'utils';
//import { SiteLink } from 'shared/link/siteLink';
//import { useRouter } from 'shared/router/useRouter';
//import { useParams, useLocation, useHistory, useRouteMatch } from 'react-router-dom';
import { useState, useEffect } from 'react';
//import { usePost } from 'components';
import { useForm } from 'form';
import { getSearchAtdwModel } from './searchAtdwModel';
import Collapsible from 'react-collapsible';

export function SearchAtdw(props) {

    //example
    //const {...params} = useRouter();
    //console.log("props id", params.query.id);
    // const { id } = useParams();

    const model = getSearchAtdwModel({});
    //const emailReceiver = "sangmin@jaba.com.au";
    const form = useForm(model, { usePlaceholder: true });

    const [test, setTest] = useState({
        form: form,
        model: model,
        trigger: 0
    });

    //const post = usePost();

    //const [submitBtn, setSubmitBtn] = useState();
    const [request, setRequest] = useState();
    const [statusText, setStatusText] = useState("");
    const [addATdwModel, setAddATdwModel] = useState();
    const [result, setResult] = useState([]);

    const render = (name) => test.form.renderControl(name, null);

    //example
    // useEffect(() => {
    //     console.log("adfsfsdf");
    //     get.send(env.apiBase + `/api/atdwadmin/test`);
    // }, [idOrName]);

    //example
    // const onSubmit = (e) => {
    //      e.preventdefault();
    //     console.log("e");
    // };

    // function onSubmit(e) {
    //     //console.log('submitting', idOrName)
    //     e.preventdefault();
    //     //setRequest("aaaaa");
    // }

    //example
    useEffect(() => {
        if (!request) {
            return;
        }
        console.log('request', request);
        const fetchData = async () => {
            let sendData = {
                searchType: request.searchType,
                searchKeyword: request.searchkeyword
            };
            const res = await fetch(
                env.apiBase + "/api/atdwadmin/searchatdw", {
                method: 'post',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(sendData)
            }
            );
            const data = await res.json();
            console.log(data);

            if (data && data.length > 0) {
                setStatusText("");
            }
            else {
                setStatusText("No Result");
            }
            setResult(data);
        };
        fetchData();
    }, [request]);

    useEffect(() => {
        if (!addATdwModel) {
            return;
        }
        const fetchData = async () => {
            const res = await fetch(
                env.apiBase + "/api/atdwadmin/addatdw", {
                method: 'post',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(addATdwModel)
            }
            );
            const data = await res.json();
            if (data.numberOfResults !== "error") {
                setResult([]);
                setTest(pre => {
                    //console.log("aaavs", pre);
                    let _new = { ...pre };
                    _new.form.model.controls[0].value = '';
                    return _new;
                });
                //form.reset(model);
            }
            //console.log("data", data);
        };
        fetchData();
    }, [addATdwModel])

    function onSubmit(e) {
        form.validateForm(e, () => {
            const value = { ...form.getValue() };
            setStatusText("Searching.....");
            setResult([]);
            setRequest(value);
        })
        //console.log('submitting', );
    }

    return (
        <>
            <h1> Search ATDW  </h1>
            <form>
                <span> Please select search type : </span>
                {/* <div>
                    {render('searchType')}
                </div> */}
                <div className="form-group">
                    {render('searchkeyword')}
                </div>

                {/* <button type="submit" onClick = {(e) => {
                        onSubmit();
                        e.preventDefault();
                    }} className="btn btn-primary">
                    Search ATDW
                </button> */}
                <button type="submit" onClick={onSubmit} className="btn btn-primary">
                    Search ATDW
                </button>
            </form>
            <div>
                {result.map((item, index) => {
                    return (
                        <div className="row search__tile" key={index}>
                            <div className="col-6 col-sm-6 col-lg-3">
                                <img src={item.imageUrl} alt={item.productName} />
                            </div>
                            <div className="col-6 col-sm-6 col-lg-9">
                                <div>
                                    {'Name : ' + item.productName}
                                </div>
                                <div>
                                    {'Town : ' + item.town}
                                </div>
                                <div>
                                    {'Address : ' + item.address}
                                </div>
                                <div style={{ marginTop: '1.5rem' }}>
                                    <button className="btn btn-primary" disabled={item.featured} onClick={() => {
                                        setAddATdwModel(item);
                                    }}> {item.featured ? 'ADDED' : 'ADD'} </button>
                                </div>
                            </div>
                            <div className="col-12" style={{ paddingTop: '0.5rem' }}>
                                <Collapsible className="desc" trigger="Description">
                                    <p>
                                        {item.shortDesc}
                                    </p>
                                </Collapsible>
                            </div>
                        </div>
                    )
                })}
                <div style={{ margin: '2rem 0px', textAlign: 'center', fontSize: '2rem' }}>
                    {statusText}
                </div>
            </div>
        </>
    );
}